'use client';

import React, { FC, useState, useEffect } from 'react';

import { TypeGlobalNavFields } from '@/core/generated-types';

import { usePathname } from '@/navigation';

import { LargeNav } from './LargeNav/LargeNav';
import { MessageBanner } from './MessageBanner/MessageBanner';
import { SmallNav } from './SmallNav/SmallNav';
import { useComponentLoading } from '@/hooks/useComponentLoading';

export type NavComponentProps = TypeGlobalNavFields & {
  isSticky: boolean;
};

const getButtonCta = (
  pathname: string,
  homeCta: TypeGlobalNavFields['homeCta'],
  pklpCta: TypeGlobalNavFields['pklpCta'],
) => {
  if (pathname === '/') {
    return homeCta;
  }

  if (
    pathname === '/products/the-play-kits' ||
    pathname.includes('/products/the-play-kits/')
  ) {
    return pklpCta;
  }

  return undefined;
};

const GlobalNav: FC<TypeGlobalNavFields> = (props) => {
  const { homeCta, pklpCta } = props;

  const pathname = usePathname();

  const buttonCta = getButtonCta(pathname, homeCta, pklpCta);

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 200);
    };

    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // This is a workaround to prevent hydration errors due to client side loading
  const componentLoading = useComponentLoading();

  if (componentLoading) {
    return null;
  }

  return (
    <>
      <MessageBanner {...props} />

      <LargeNav {...props} isSticky={isScrolled} buttonCta={buttonCta} />

      <SmallNav {...props} isSticky={isScrolled} buttonCta={buttonCta} />
    </>
  );
};

export default React.memo(GlobalNav);
